<!-- 新增地址 -->
<template>
<div>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="750px" 
            :before-close="closeDialog" append-to-body>
        <el-form :model="ruleForm" :rules="rules" ref="formRef" label-width="100px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="姓名" prop="name">  
                        <el-input v-model="ruleForm.name" placeholder="请输入姓名" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="电话" prop="phone">  
                        <el-input v-model="ruleForm.phone" placeholder="请输入电话" ></el-input>
                    </el-form-item>
                </el-col>          
            </el-row>
            <el-row>  
                <el-col :span="12"> 
                <el-form-item label="省市区" prop="selectedAddress">
                    <el-cascader
                        v-model="ruleForm.selectedAddress"
                        :options="areaList"
                        :props="optionProps"
                        placeholder="请选择省/市/区"
                        style="width: 100%;"
                         @change="handleAddressChange"
                        />  
                </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="默认地址" prop="isDefault">  
                        <el-radio-group v-model="ruleForm.isDefault"> 
                            <el-radio :label="item.value" 
                                v-for="item in typeOption" 
                                :key="item.label">{{ item.label }}</el-radio>                       
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <!-- <el-form-item label="省市" required>
                    <el-col :span="8">
                        <el-form-item prop="province">
                            <el-select v-model="ruleForm.province"  @change="handleChangeArea">
                                <el-option
                                    v-for="item in areaList"
                                    :key="item.code"
                                    :label="item.label"
                                    :value="item.label"                                    
                                    >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>                 
                    <el-col :span="8">
                        <el-form-item prop="city">
                            <el-select v-model="ruleForm.city"  @change="handleChangecity">
                                <el-option
                                    v-for="item in cityList"
                                    :key="item.code"
                                    :label="item.label"
                                    :value="item.label"
                                    >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>  
                    <el-col :span="8">
                        <el-form-item prop="district">
                            <el-select v-model="ruleForm.district"  @change="handleChangeDistrict">
                                <el-option
                                    v-for="item in districtList"
                                    :key="item.code"
                                    :label="item.label"
                                    :value="item.label"
                                    >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>                          
                </el-form-item> -->
            </el-row>
            <el-row>
                <el-form-item label="详细地址" prop="addressDetail">
                    <el-input type="text" v-model="ruleForm.addressDetail" placeholder="请输入详细地址"/>
                </el-form-item>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取消</el-button>
            <el-button type="primary" @click="confirmDialog">确定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import { provinceData } from '@/assets/js/area'
export default {
    props:{       
        title:{
            type: String,
            default: ''
        },
        formData: {
            type: Object,
            default:{}
        },
    },
    data() {
        return {
            dialogTitle: '',
            dialogVisible: true,
            cityList: [],
            areaList:provinceData,
            districtList: [],
            ruleForm: {
                name: '',
                phone: '',
                province: '',
                city: '',
                district: '',
                addressDetail: '',
                isDefault: '0',
                selectedAddress: [],
            },
            typeOption: [
                {value:'0',label:'是'},
                {value:'1',label:'否'},
            ],
            rules: {  
                name :[
                    { required: true, message: '请输入发件人姓名', trigger: 'blur' },
                ], 
                phone: [
                    { required: true, message: '请输入发件人电话', trigger: 'blur' },
                ],
                selectedAddress: [
                    { required: true, message: '请选择发件人地址', trigger: 'change' },
                ],
                addressDetail: [
                    { required: true, message: '请输入发件人详细地址', trigger: 'blur' },
                ]                
            },
            selectedAddress: [],
            // 级联选择器配置
            cascaderProps: {
                expandTrigger: 'hover', // 鼠标悬停展开下级
                checkStrictly: false,   // 是否严格遵守父子不关联
                emitPath: true          // 返回选中节点的路径
            },
            optionProps: { //配置节点
                value: 'label',
                label: 'label',
                children: 'children'
            },
        }
    },
    created() {
       
    },
    mounted() {        
        if(this.title === '编辑地址'){
            this.ruleForm = {...this.formData}
            this.ruleForm.selectedAddress = [this.formData.province,this.formData.city,this.formData.district]
        }
    },
    methods: {        
        handleChangeArea(value){
            console.log(value)
            this.cityList = []
            this.ruleForm.province = value
            this.ruleForm.city = ''
            let cityObj = this.areaList.filter(i=> i.label === value)
            this.cityList = cityObj[0].cities
        },
        handleChangecity(value){
            this.ruleForm.city = value
        },
        handleChangeDistrict(){

        },
        closeDialog(){
            this.resetForm()
            this.$emit('close');
        },
        resetForm(){
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            } else {
                console.error('表单组件未找到');
            }
        },
        confirmDialog(){
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    // 校验通过，传递表单数据到父组件
                    this.handleSubmit()    
                } else {
                    window.scrollTo({
                        top:0,
                        behavior: 'smooth'
                    })
                    console.log('表单校验失败');
                    return false;
                }
            });
        },
        handleSubmit(){            
            let { province, city, district, name, phone, addressDetail,isDefault} = this.ruleForm
            province = this.ruleForm.selectedAddress[0]
            city = this.ruleForm.selectedAddress[1]
            district = this.ruleForm.selectedAddress[2]
            let params = {}
            if(this.title === '编辑地址' ){
                params = {
                    opcode: this.$code.UpdateAddress,
                    i_serial: this.formData.id,
                    v_province: province,
                    v_city: city,
                    v_county: district,
                    v_phone: phone,
                    v_location: addressDetail,
                    v_peopel: name,
                    c_default: isDefault,
                    v_label: ''
                }
            }else{
               params = {
                    opcode: this.$code.AddAddress,
                    v_province: province,
                    v_city: city,
                    v_county: district,
                    v_phone: phone,
                    v_location: addressDetail,
                    v_peopel: name,
                    c_default: isDefault,
                    v_label: ''
                }
            }           
            console.log(params)
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.$emit('confirm');
                    if(this.title === '编辑地址'){
                        this.$message.success('编辑地址成功')
                    }else{
                        this.$message.success('添加地址成功')
                    }
                }else{
                    this.$message.success(res.Message)
                }
            })
        },
        handleAddressChange(value){
            console.log('选中的地址:', value);
            this.ruleForm.province = value[0]
        }
    }
}
</script>
<style lang='scss' scoped>

</style>


// WEBPACK FOOTER //
// src/views/product/components/addAddress.vue